import { render, staticRenderFns } from "./SmartClickWrapper.vue?vue&type=template&id=49ec15ae"
import script from "./SmartClickWrapper.vue?vue&type=script&lang=js"
export * from "./SmartClickWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports